import {css} from 'lit';
export const PanelfullregionobjectsSharedStyles = css`::slotted(.block-panel-element) {
    flex: 1;
}

::slotted(keli-browse) {
    flex: 1;
    --keli-browse-height: 100%;
}

::slotted(keli-markdown) {
    max-width: none !important;
    flex: 1 1 100% !important;
    padding: 10px 20px 20px 20px;
    box-sizing: border-box;
    overflow: auto;
}

::slotted(keli-calendar) {
    flex: 1 1 100% !important;
    display: flex !important;
    overflow: auto;
    height: 100%;
}

::slotted(keli-codearea) {
    flex: 1;
}

::slotted(keli-map) {
    flex: 1;
    height: 100% !important;
}

::slotted(keli-image-viewer) {
    flex: 1;
    height: 100% !important;
}

::slotted(keli-discussion) {
    flex: 1 !important;
    max-height: none !important;
    border: none !important;
    margin: 0 !important;
    overflow: hidden !important;
    --keli-discussion-resize-handle-display: none;
}

::slotted(keli-chart-bar),
::slotted(keli-chart-line),
::slotted(keli-chart-pie) {
    flex: 1;
    height: 100% !important;
}

::slotted(keli-report-editor) {
    flex: 1;
    height: 100% !important;
}`;

import {html} from '@polymer/polymer';
export const PanelfullregionobjectsSharedStylesHTML = html`<style>::slotted(.block-panel-element) {
    flex: 1;
}

::slotted(keli-browse) {
    flex: 1;
    --keli-browse-height: 100%;
}

::slotted(keli-markdown) {
    max-width: none !important;
    flex: 1 1 100% !important;
    padding: 10px 20px 20px 20px;
    box-sizing: border-box;
    overflow: auto;
}

::slotted(keli-calendar) {
    flex: 1 1 100% !important;
    display: flex !important;
    overflow: auto;
    height: 100%;
}

::slotted(keli-codearea) {
    flex: 1;
}

::slotted(keli-map) {
    flex: 1;
    height: 100% !important;
}

::slotted(keli-image-viewer) {
    flex: 1;
    height: 100% !important;
}

::slotted(keli-discussion) {
    flex: 1 !important;
    max-height: none !important;
    border: none !important;
    margin: 0 !important;
    overflow: hidden !important;
    --keli-discussion-resize-handle-display: none;
}

::slotted(keli-chart-bar),
::slotted(keli-chart-line),
::slotted(keli-chart-pie) {
    flex: 1;
    height: 100% !important;
}

::slotted(keli-report-editor) {
    flex: 1;
    height: 100% !important;
}</style>`;
